import { CalculationMethod, CalculationParameters, Coordinates, PrayerTimes, Prayer } from 'adhan';
import { CalcSettings, LocationData } from '../types';

export const buildPrayerTimesForDate = (
  city: string,
  date: Date,
  location: LocationData,
  calcSettings: CalcSettings
): PrayerTimes => {
  const coordinates = new Coordinates(location.latitude, location.longitude);
  const params = getCalculationParams(calcSettings);
  return new PrayerTimes(coordinates, date, params);
};

export const getCalculationParams = (settings: CalcSettings): CalculationParameters => {
  const methodMap: Record<string, () => CalculationParameters> = {
    MuslimWorldLeague: CalculationMethod.MuslimWorldLeague,
    Egyptian: CalculationMethod.Egyptian,
    Karachi: CalculationMethod.Karachi,
    UmmAlQura: CalculationMethod.UmmAlQura,
    Dubai: CalculationMethod.Dubai,
    MoonsightingCommittee: CalculationMethod.MoonsightingCommittee,
    NorthAmerica: CalculationMethod.NorthAmerica,
    Kuwait: CalculationMethod.Kuwait,
    Qatar: CalculationMethod.Qatar,
    Singapore: CalculationMethod.Singapore,
  };

  const params = (methodMap[settings.method] || CalculationMethod.MuslimWorldLeague)();
  
  if (settings.madhab === 'Hanafi') {
    (params as any).madhab = 1;
  }

  return params;
};

export const listPrayerTimes = (pt: PrayerTimes) => [
  { name: 'Fajr', at: pt.fajr, id: 'fajr' },
  { name: 'Sunrise', at: pt.sunrise, id: 'sunrise' },
  { name: 'Dhuhr', at: pt.dhuhr, id: 'dhuhr' },
  { name: 'Asr', at: pt.asr, id: 'asr' },
  { name: 'Maghrib', at: pt.maghrib, id: 'maghrib' },
  { name: 'Isha', at: pt.isha, id: 'isha' },
];

export const prayerEnumToName = (p: any): string => {
  switch (p) {
    case Prayer.Fajr: return 'Fajr';
    case Prayer.Sunrise: return 'Sunrise';
    case Prayer.Dhuhr: return 'Dhuhr';
    case Prayer.Asr: return 'Asr';
    case Prayer.Maghrib: return 'Maghrib';
    case Prayer.Isha: return 'Isha';
    default: return 'Fajr';
  }
};

export const formatTime = (d: Date) => {
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const msToHhMm = (ms: number) => {
  const totalMin = Math.max(0, Math.floor(ms / 60000));
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return `${h}h ${m}m`;
};
